<script>
    export default {
        name: "login-email-field",
        props: {
            validateOnBlur: {
                type: Boolean,
                default: true
            },
            value: String,
            autofocus: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            tEmail() { return Lang.langGet('Email address') },
            rules() {
                return {
                    email: (value) => {
                        if (value) {
                            if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                                this.$emit('valid', 'email', true);
                                return true;
                            }

                            this.$emit('valid', 'email', false);
                            return Lang.langGet('E-mail must be valid');
                        }

                        this.$emit('valid', 'email', false);
                        return Lang.langGet('You must enter an ') + 'Email';
                    }
                }
            }
        }
    }
</script>

<template>
    <v-text-field
        id="input" aria-label="email" type="text" name="email"
        :placeholder="tEmail"
        :rules="[rules.email]"
        :validateOnBlur="validateOnBlur"
        :value="value"
        :autofocus="autofocus"
        required outlined dense
    />
</template>
